// extracted by mini-css-extract-plugin
module.exports = {"button":"form-button_button_2yY-X"};